import React, { useEffect, useState } from "react";
import "./App.css";
import AuthRoutes from "./navigation/AuthRoutes";
import { useAppSelector } from "./redux/store";
import RootRoutes from "./navigation/RootRoutes";
import secureLocalStorage from "react-secure-storage";
import { Toaster } from 'react-hot-toast'
import { ReferralShareSheet } from "./components/ReferralShareSheet";
function App() {
  const { login } = useAppSelector((state) => state.root);
  const [accessToken, setAccessToken] = useState<any>(null);

  useEffect(() => {
    const storage = secureLocalStorage.getItem("user");
    setAccessToken(storage);
  }, [login]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // You can change this to 'auto' for instant scrolling
    });
  }, [])

  return (
    <div className="App h-screen w-screen relative ">
      <Toaster />
      <ReferralShareSheet />
      {!accessToken ? (
        <AuthRoutes />
      ) : (
        <>
          <RootRoutes />
        </>
      )}
    </div>
  );
}

export default App;
